import { Box, Typography } from '@mui/material';

export default function CautionBar({
  text,
  bgColor,
  onClick
}: {
  text?: string;
  bgColor?: string;
  onClick?: () => void;
}) {
  return (
    <Box
      sx={{
        width: '100%',
        textAlign: 'center',
        padding: '8px',
        top: 0,
        left: 0,
        backgroundColor: bgColor || '#ffcc00',
        cursor: 'pointer',
        borderRadius: '6px'
      }}
      onClick={onClick}>
      <Typography variant="body1">{text}</Typography>
    </Box>
  );
}
